import { httpClient } from '../httpClient';
import { API_ENDPOINTS } from '../endpoints';

// Public APIs
export const register = async (phone) => {
    const response = await httpClient.post(API_ENDPOINTS.REGISTER, {phone});
    return response.data.data;
};

export const resendOtp = async (phone) => {
    const response = await httpClient.post(API_ENDPOINTS.RESEND, {phone});
    return response.data.data;
};

export const verify = async (phone, otp) => {
    const response = await httpClient.post(API_ENDPOINTS.VERIFY, {phone, otp});
    return response.data.data;
};

export const login = async (phone, password) => {
    const response = await httpClient.post(API_ENDPOINTS.LOGIN, {phone, password});
    return response.data.data;
};

export const logout = async () => {
    const response = await httpClient.post(API_ENDPOINTS.LOGOUT);
    return response.data.data;
};

// Protected APIs
export const setPassword = async (protectedClient, password) => {
    const response = await protectedClient.post(API_ENDPOINTS.PASSWORD, {password});
    return response.data.data;
};

export const sendKyc = async (protectedClient, nationalId, birthDate) => {
    const response = await protectedClient.post(API_ENDPOINTS.KYC, {nationalId, birthDate});
    return response.data.data;
};